import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from "swiper/modules";
import 'swiper/css';
import 'swiper/css/pagination';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux-stores/store';
import { Ticker as TickerItemType } from '../../redux-stores/slices/authSlice';
const Ticker = () => {

    const tickers = useSelector((state: RootState) => state.auth.user?.tickers)

    const navigate = useNavigate();

    const getBackgroundColor = (tickerItem: TickerItemType) => {

        if (tickerItem.color) {
            return 'bg-' + tickerItem.color
        }

        return 'bg-primary';
    }

    const slideClickHandler = (item: TickerItemType) => {
        if (item.url) {
            if (item.url.includes('http')) {
                window.open(item.url, '_blank');
            } else {
                navigate(item.url)
            }
        }
    }

    if (!Array.isArray(tickers) || tickers.length === 0) return null;

    return (
        <Swiper pagination={true} autoplay={true} loop={(Array.isArray(tickers) && tickers.length > 1)} modules={[Autoplay]} className="mySwiper ticker-swiper">
            {
                tickers && tickers.map((item, i) => {
                    return (
                        <SwiperSlide key={i}>
                            <div onClick={() => slideClickHandler(item)} className={`ticker text-white px-3 d-flex justify-content-between align-items-center`}>
                                <div className="d-flex flex-column w-75 gap-1">
                                    <span className="ticker-title text-start text-truncate">{item.title}</span>
                                    <span className="ticker-description text-start text-truncate">{item.description}</span>
                                </div>
                                {
                                    (item.cta_text) ? (<span className="ticker-cta text-start text-truncate">{item.cta_text}</span>) : (<span><i className="fa-solid fa-chevron-right"></i></span>)
                                }
                            </div>
                        </SwiperSlide>
                    )
                })
            }
        </Swiper>
    )
}

export default Ticker